import { LatamAgentPage } from '@/screens/Latam/Agents/LatamAgentPage';

export default function AgentClaimsPage() {
  return <LatamAgentPage locale="pt-BR" agentKey="claims_processing" />;
}
